import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import {withTranslation} from "react-i18next";

class Error extends Component {
    render() {
        const { t } = this.props;
        return (
            <div className="middle-box text-center animated fadeInDown">
                <h1>404</h1>
                <h3 className="font-bold">{ t('notfound') }</h3>
                <div className="error-desc">
                    Nội dung của trang không tồn tại.
                </div>
                <Link to={'/'} className={`mb-2`}>{ t('action.backIndex') }</Link>
            </div>
        );
    }
}

export default withTranslation()(Error);